<h2>{{ 'popins.delete.title' | translate }}</h2>
<p class="mt-2 mb-4">{{ 'popins.delete.info' | translate }}</p>
<div class="text-center">
    <ng-hbm-bdi-btn class="light-grey mr-3" (click)="cancel()" [label]="'generic.no' | translate"></ng-hbm-bdi-btn>
    <ng-hbm-bdi-btn class="primary" (click)="confirm()" [label]="'generic.yes' | translate"></ng-hbm-bdi-btn>
</div>